import { makeStyles } from '@griffel/react';
import type { GriffelClassNames } from '@ms/yammer-web-core-ui/dist/util/classNames';
import { getGutterValue } from '@ms/yammer-web-core-ui/dist/util/styles/gutters';
import { px } from '@ms/yammer-web-core-ui/dist/util/styling';

const expandedHeight = 32;

const useClasses = makeStyles({
  button: {
    minWidth: 'unset',
    height: px(expandedHeight),
    paddingLeft: getGutterValue(1.5),
    paddingRight: getGutterValue(1.5),
  },
});

export const useClassNames = (): GriffelClassNames<'button'> => {
  const classes = useClasses();

  return {
    button: classes.button,
  };
};
